import Vue from 'vue';
import {indexOf, map} from 'lodash';
import {
    createDisposition,
    loadDispositions,
    removeDisposition,
    updateDisposition
} from '../../modules/api/disposition.api';

export const getters = {
    dispositions:                (state) => state.dispositions,
    customDispositions:          (state) => state.dispositions.filter(({ systemic }) => !systemic),
    systemDispositions:          (state) => state.dispositions.filter(({ systemic }) => systemic),
    dispositionsForAutocomplete: (state) => state.dispositions.map(({ id, title }) => {
        return { name: title, id };
    }),
    loadDispositionById:         (state, getters) => (dispositionId) => {
        return new Promise((resolve) => resolve(getters.dispositions.find((disposition) => disposition.id === dispositionId) || null));
    },
}

export const actions = {
    async createDisposition({ commit, getters }, data) {
        const projectId = getters.projectId;
        return createDisposition({ ...data, projectId }).then((data) => commit('ADD_DISPOSITION', data))
    },
    async updateDisposition({ commit }, data) {
        return updateDisposition(data).then((data) => commit('UPDATE_DISPOSITION', data))
    },
    async removeDisposition({ commit }, dispositionId) {
        return removeDisposition(dispositionId).then((id) => commit('REMOVE_DISPOSITION', id))
    },
    async loadDispositions({ commit, getters }) {
        return loadDispositions(getters.projectId).then((data) => commit('SET_DISPOSITIONS', data));
    },
}

export const mutations = {
    SET_DISPOSITIONS:   (state, dispositionsData) => state.dispositions = dispositionsData,
    ADD_DISPOSITION:    (state, dispositionData) => state.dispositions.push(dispositionData),
    UPDATE_DISPOSITION: (state, dispositionData) => {
        const index = indexOf(map(state.dispositions, (object) => object.id), dispositionData.id);
        Vue.set(state.dispositions, index, dispositionData);
    },
    REMOVE_DISPOSITION: (state, dispositionId) => {
        const index = indexOf(map(state.dispositions, (object) => object.id), dispositionId);
        if (index !== -1) {
            state.dispositions.splice(index, 1);
        }
    },
}
